import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";

export default function InfoFinance({ persona, setShowCalculatorModal, handleDownloadExistingPDF, loadingPDF, showDetailsModal, setShowDetailsModal }) {
    const [showWarningModal, setShowWarningModal] = useState(false);

    const handleModifyQuote = () => {
        // Si no hay financial_details, mostrar advertencia
        if (persona?.infoBudget?.financial_details == null) {
            setShowWarningModal(true);
        } else {
            setShowCalculatorModal(true);
        }
    };

    const confirmModifyQuote = () => {
        setShowWarningModal(false);
        setShowCalculatorModal(true);
    };

    return (
        <>
        {/* Información del Cliente */}
        <div className="col-12 md:col-6 lg:col-4">
            <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                <div className="flex align-items-center gap-3 mb-3">
                    <i className="pi pi-user text-green-600 text-xl"></i>
                    <h4 className="m-0 text-gray-800">Información del Cliente</h4>
                </div>
                <div className="text-gray-600">
                    <div className="mb-2">
                        <strong>Nombre en la Cotización:</strong> {persona?.infoBudget?.name}
                    </div>
                    <div className="mb-2">
                        <strong>ID:</strong> {persona?.infoBudget?.insurance_id}
                    </div>
                    <div className="mb-2">
                        <strong>Plazo:</strong> {persona?.infoBudget?.term} meses
                    </div>
                </div>
            </div>
        </div>

        {/* Información del Vehículo */}
        <div className="col-12 md:col-6 lg:col-4">
            <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                <div className="flex align-items-center gap-3 mb-3">
                    <i className="pi pi-car text-orange-600 text-xl"></i>
                    <h4 className="m-0 text-gray-800">Información del Vehículo</h4>
                </div>
                <div className="text-gray-600">
                    <div className="mb-2">
                        <strong>Marca:</strong> {persona?.infoBudget?.vehicle?.brand}
                    </div>
                    <div className="mb-2">
                        <strong>Modelo:</strong> {persona?.infoBudget?.vehicle?.model}
                    </div>
                    <div className="mb-2">
                        <strong>Año:</strong> {persona?.infoBudget?.vehicle?.year}
                    </div>
                </div>
            </div>
        </div>

        {/* Detalles Técnicos */}
        <div className="col-12 md:col-6 lg:col-4">
            <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                <div className="flex align-items-center gap-3 mb-3">
                    <i className="pi pi-cog text-purple-600 text-xl"></i>
                    <h4 className="m-0 text-gray-800">Detalles Técnicos</h4>
                </div>
                <div className="text-gray-600">
                    <div className="mb-2">
                        <strong>Tipo:</strong> {persona?.infoBudget?.vehicule_type}
                    </div>
                    <div className="mb-2">
                        <strong>Motor:</strong> {persona?.infoBudget?.engine}
                    </div>
                    <div className="mb-2">
                        <strong>Placa:</strong> {persona?.infoBudget?.state_plate_id}
                    </div>
                </div>
            </div>
        </div>

        {/* Descripción */}
        {persona?.infoBudget?.vehicle?.description && (
            <div className="col-12 md:col-12">
                <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                    <div className="flex align-items-center gap-3 mb-3">
                        <i className="pi pi-info-circle text-blue-600 text-xl"></i>
                        <h4 className="m-0 text-gray-800">Descripción</h4>
                    </div>
                    <div className="text-gray-600">
                        {persona?.infoBudget?.vehicle?.description}
                    </div>
                </div>
            </div>

        )}

        {/* Información Financiera */}
        <div className="col-12 md:col-6">
            <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                <div className="flex align-items-center gap-3 mb-3">
                    <i className="pi pi-dollar text-green-600 text-xl"></i>
                    <h4 className="m-0 text-gray-800">Información Financiera</h4>
                </div>
                <div className="text-gray-600">
                    <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <strong>Precio:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.price || 0)}
                    </div>
                    <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <strong>Precio sin IVA:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.price_without_iva || 0)}
                    </div>
                    <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <strong>Enganche:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.down_payment || 0)}
                    </div>
                </div>
            </div>
        </div>

        {/* Información de Pagos */}
       {/*  <div className="col-12 md:col-6">
            <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                <div className="flex align-items-center gap-3 mb-3">
                    <i className="pi pi-credit-card text-blue-600 text-xl"></i>
                    <h4 className="m-0 text-gray-800">Información de Pagos</h4>
                </div>
                <div className="text-gray-600">
                    <div className="mb-2">
                        <strong>Renta Mensual:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.monthly_rent || 0)}
                    </div>
                    <div className="mb-2">
                        <strong>Renta Mensual sin IVA:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.monthly_rent_without_iva || 0)}
                    </div>
                    <div className="mb-2">
                        <strong>Pago Inicial:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.initial_payment || 0)}
                    </div>
                    <div className="mb-2">
                        <strong>Valor de Pago:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.payment_value || 0)}
                    </div>
                    <div className="mb-2">
                        <strong>Valor de Pago sin IVA:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.payment_value_without_iva || 0)}
                    </div>
                </div>
            </div>
        </div> */}

        

        {/* Detalles Financieros Completos */}
        {persona?.infoBudget?.financial_details ? (
            <>
                {/* Desglose de Enganche */}
                {persona.infoBudget.financial_details.groupConceptsEnganche && (
                    <div className="col-12 md:col-6">
                        <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                            <div className="flex align-items-center gap-3 mb-3">
                                <i className="pi pi-money-bill text-orange-600 text-xl"></i>
                                <h4 className="m-0 text-gray-800">Desglose de Enganche</h4>
                            </div>
                            <div className="text-gray-600">
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Enganche:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.enganche || 0)}
                                </div>
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Comisión Apertura:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.comisionApertura || 0)}
                                </div>
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Renta Anticipada:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.rentaAnticipada || 0)}
                                </div>
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Gastos Originación:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.gastosOriginacion || 0)}
                                </div>
                                {/* <div className="mb-2 border-top-1 border-gray-300 pt-2">
                                    <strong>Subtotal:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.subtotal || 0)}
                                </div> */}
                                <div className="mb-2 border-top-1 border-gray-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Subtotal (sin IVA):</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.subWithoutIva || 0)}
                                </div>
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>IVA:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.subWitIva || 0)}
                                </div>
                                <div className="mb-2 border-top-1 border-gray-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}> 
                                    <strong>Total (incl IVA):</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.totalWitIva || 0)}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Desglose de Conceptos */}
                {persona.infoBudget.financial_details.groupConcepts && (() => {
                    const fd = persona.infoBudget.financial_details;
                    const rentaTotal = fd.groupConcepts.rentaTotal || 0;
                    const iva = fd.iva_percentage ? parseFloat(fd.iva_percentage) / 100 : 0.16;
                    const esFinance = fd.typeBudget === 'finance';
                    // Finance: rentaTotal viene CON IVA. Pure: viene SIN IVA.
                    const totalSinIva = esFinance ? rentaTotal / (1 + iva) : rentaTotal;
                    const totalConIva = esFinance ? rentaTotal : rentaTotal * (1 + iva);
                    const ivaMonto = totalConIva - totalSinIva;
                    const fmt = (val) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
                    return (
                    <div className="col-12 md:col-6">
                        <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                            <div className="flex align-items-center gap-3 mb-3">
                                <i className="pi pi-calculator text-purple-600 text-xl"></i>
                                <h4 className="m-0 text-gray-800">Desglose de Conceptos</h4>
                            </div>
                            <div className="text-gray-600">
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Renta Total (sin IVA):</strong> {fmt(totalSinIva)}
                                </div>
                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>IVA:</strong> {fmt(ivaMonto)}
                                </div>
                                <div className="mb-2 border-top-1 border-gray-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <strong>Total (incl IVA):</strong> {fmt(totalConIva)}
                                </div>
                                <div className="mt-3 pt-2 border-top-1 border-gray-300">
                                    <Button
                                        label="Ver Desglose Completo"
                                        icon="pi pi-eye"
                                        className="p-button-outlined p-button-sm w-full Blue "
                                        onClick={() => setShowDetailsModal(true)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    );
                })()}

                {/* Información Adicional */}
                <div className="col-12 md:col-6">
                    <div className="p-4 border-round-lg border-1 border-gray-200 shadow-sm h-full">
                        <div className="flex align-items-center gap-3 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-xl"></i>
                            <h4 className="m-0 text-gray-800">Información Adicional</h4>
                        </div>
                        <div className="text-gray-600">
                            <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <strong>IVA %:</strong> {(persona.infoBudget.financial_details.iva_percentage || 0)}%
                            </div>
                            <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <strong>Tasa:</strong> {(persona.infoBudget.financial_details.tasa || 'N/A')}%
                            </div>
                            <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <strong>Comisión:</strong> {(persona.infoBudget.financial_details.commission || 'N/A')}%
                            </div>
                            <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <strong>Gps:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.gps || 'N/A')}
                            </div>
                            <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <strong>Calculado:</strong> {new Date(persona.infoBudget.financial_details.calculated_at).toLocaleDateString('es-MX')}
                            </div>
                        </div>
                    </div>
                </div>
            </>
            ) : (
                <div className="col-12 md:col-6">
                    <div className="p-4 border-round-lg border-1 border-red-200 shadow-sm h-full bg-red-100">
                        <div className="flex align-items-center gap-3 mb-3">
                            <i className="pi pi-info-circle text-red-600 text-xl"></i>
                            <h4 className="m-0 text-gray-800">No hay información financiera</h4>
                        </div>
                        <div className="text-gray-600">
                            <p className="mb-3">
                                Esta cotización no cuenta con detalles financieros porque fue creada en una versión anterior del sistema.
                            </p>
                            <p className="mb-3">
                                <strong>Para generar esta información:</strong>
                            </p>
                            <ul className="pl-4 mb-0">
                                <li className="mb-2">
                                    Accede al cotizador y modifica la cotización actual
                                </li>
                                <li className="mb-2">
                                    <div>No necesitas cambiar ningún dato, simplemente vuelve a generarla</div>
                                    <div className="mt-2 p-2 bg-yellow-50 border-left-3 border-yellow-400 border-round" style={{ borderLeft: '3px solid #fbbf24' }}>
                                        <div className="flex align-items-start gap-2">
                                            <i className="pi pi-exclamation-triangle text-yellow-600 text-sm mt-1"></i>
                                            <span className="text-gray-700 text-sm" style={{ fontStyle: 'italic' }}>
                                                Ten en cuenta que la cotización se generará con la información actual y puede tener variaciones debido al seguro o al mes en que se realiza.
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    Los detalles financieros se generarán automáticamente
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}  
        

        {/* Botones de Acción */}
        <div className="col-12">
            <div className="flex gap-3 flex-wrap">
                <Button
                    label="Modificar Cotización"
                    icon="pi pi-pencil"
                    className="p-button-primary Green Button"
                    onClick={handleModifyQuote}
                />
                <Button
                    label="Descargar PDF"
                    icon="pi pi-file-pdf"
                    className="p-button-outlined p-button-info Button"
                    onClick={handleDownloadExistingPDF}
                    loading={loadingPDF}
                    disabled={!persona?.infoBudget?.secret}
                />
            </div>
        </div>
        {/*    <NewCalculator budgetData={persona?.infoBudget} id={persona?.id} /> */}

        {/* Modal de Advertencia */}
        <Dialog
            visible={showWarningModal}
            modal
            closable={true}
            onHide={() => setShowWarningModal(false)}
            draggable={false}
            style={{ width: "50vw" }}
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            header={
                <div className="header-with-image flex mb-0">
                    <h2
                       style={{
                            background: "linear-gradient(90deg, #21588C 6.22%, #21588C 77.34%)",
                            WebkitBackgroundClip: "text",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }} 
                    >
                        Advertencia
                    </h2>
                </div>
            }
        >
            <p
                style={{
                    marginBottom: "1rem",
                    fontSize: "calc(0.6rem + 0.9vw)",
                    color: "#21588C",
                    fontWeight: 600,
                }}
            >
                Información importante
            </p>
            <p
                className="content m-0"
                style={{
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "166.667%",
                    fontSize: "calc(0.4rem + 0.9vw)",
                    marginBottom: "1.5rem",
                }}
            >
                Esta cotización no cuenta con detalles financieros porque fue creada en una versión anterior del sistema.
            </p>

            <div className="mt-2 p-3 bg-yellow-50 border-left-3 border-yellow-400 border-round" style={{ borderLeft: '3px solid #fbbf24', marginBottom: "1.5rem" }}>
                <div className="flex align-items-start gap-2">
                    <i className="pi pi-exclamation-triangle text-yellow-600 text-lg mt-1"></i>
                    <span className="text-gray-700" style={{ fontStyle: 'italic', fontSize: "calc(0.4rem + 0.9vw)" }}>
                        La cotización se generará con la información actual y puede tener variaciones debido al seguro o al mes en que se realiza.
                    </span>
                </div>
            </div>

            <div className="flex gap-3 justify-content-end mt-4">
                <Button
                    label="Cancelar"
                    icon="pi pi-times Button "
                    className="p-button-outlined p-button-secondary Button"
                    onClick={() => setShowWarningModal(false)}
                />
                <Button
                    label="Continuar"
                    icon="pi pi-check"
                    className="Button Green"
                    onClick={confirmModifyQuote}
                />
            </div>
        </Dialog>
    </>
    )
}